import { ReplaySubject } from 'rxjs';
import { filter } from 'rxjs/operators';
import { Connection } from './connection';
import { CHANNEL, IWebsocketMessage, IWebsocketServerMessage, TOPIC } from 'types';

export let socketConn: undefined | Connection;
export let socketSubject: ReplaySubject<unknown>;

export async function connect(url: string, token: string) {
  if (!url || !token) {
    throw new Error('No wss url or token passed through!');
  }
  // need to wait for A: window.globalConfig.wssUrl and B: user to be authenticated
  const wssUrl = `${url}?token=${token}`;
  socketSubject = new ReplaySubject(1);
  socketConn = new Connection(wssUrl, {
    onMessage: data => {
      // console.log('handle message called', data);
      socketSubject.next(data);
    }
  });

  return await socketConn.connect();
}

export function socketObservable(options: { channel: CHANNEL; view: string; topic: Array<TOPIC>; subject?: string }) {
  if (!socketConn?.isOpen) {
    console.log(`Socket not open, cannot subscribe to channel: ${options.channel}`);
    return;
  }
  return socketSubject.pipe(
    filter(data => {
      let wsMessage: IWebsocketServerMessage = {} as IWebsocketServerMessage;
      try {
        // the default response from keepAlive
        if (data === 'Not Found') {
          return false;
        }
        wsMessage = JSON.parse(data as unknown as string);
        const result =
          wsMessage.channel === options.channel &&
          wsMessage.view === options.view &&
          options.topic.includes(wsMessage.topic);

        if (options.subject) {
          return result && wsMessage.subject === options.subject;
        }
        return result;
      } catch (err) {
        // unable to parse JSON message
        throw new Error(`Error parsing JSON from WS message: ${{ cause: { err, options, wsMessage } }}`); // for Sentry
      }
    })
  );
}

export function sendWSMessage(data: IWebsocketMessage) {
  if (!socketConn?.isOpen) {
    console.log('socket not open, cannot send message');
    return null;
  }
  socketConn.sendMessage(data);
}
